import type { Method } from 'axios';
import { v4 as uuid } from 'uuid';

import type { PresignFields } from 'hb-react/shared/hooks/useStorage/types';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export interface PresignResponse {
  data: { url: string; fields: PresignFields; method: Method };
}

export const presign = (
  controller: AbortController,
  filename: string,
  type: string,
): Promise<PresignResponse> =>
  axios.get(Routes.presign_path(), {
    params: { nocache: uuid(), filename, type }, // `nocache` is needed for safari
    signal: controller.signal,
  });

export const upload = ({
  method,
  url,
  controller,
  formData,
  onUploadProgress,
}: {
  method: Method;
  url: string;
  controller: AbortController;
  formData: FormData;
  onUploadProgress: (progressEvent: ProgressEvent) => void;
}) =>
  axios[method](url, formData, {
    ...(controller && { signal: controller.signal }),
    onUploadProgress,
    withCredentials: false,
  });

export const postUploadFO = (shrineKey: string) =>
  axios.post(Routes.post_upload_publish_path(), {
    key: shrineKey,
    format: 'json',
  });

export const postUploadBO = (shrineKey: string, networkId: number | string) =>
  axios.post(Routes.backoffice_network_post_upload_publish_path(networkId), {
    key: shrineKey,
    format: 'json',
  });
